import { render, staticRenderFns } from "./Invoices.vue?vue&type=template&id=bbafb048&scoped=true&"
import script from "./Invoices.vue?vue&type=script&lang=js&"
export * from "./Invoices.vue?vue&type=script&lang=js&"
import style0 from "./Invoices.vue?vue&type=style&index=0&id=bbafb048&lang=scss&scoped=true&"
import style1 from "./Invoices.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbafb048",
  null
  
)

export default component.exports